import React, { lazy, Suspense } from 'react';
import languageMapper from 'utils/languageMapper';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { ExternalLink } from 'react-feather';
import { routes } from 'constants/config';
import { useFetch } from 'hooks';
import ElementLoading from 'components/shared/ElementLoading/ElementLoading';
import ContentError from './ContentError';

const LOADING_TEXT = t('questions.types.content.loading');

const SeismicPlayer = lazy(() =>
  import(
    /* webpackChunkName: "SeismicUniversalPlayer" */ '@seismic/universal-player'
  ),
);

const UniversalPlayer = ({
  id,
  videoType,
  universalLink,
  autoplay = false,
  isPractice = false,
}) => {
  const endpoint = videoType
    ? routes.SEISMIC.EXTERNAL_VIDEO_MANIFEST(id, videoType)
    : routes.SEISMIC.PLAYER_CONFIGURATION(id);
  const { data: playerConfiguration, loading, error } = useFetch(endpoint);

  if (error || (!loading && !playerConfiguration)) {
    return <ContentError error={error?.status} />;
  }

  return (
    <ElementLoading isLoading={loading} text={LOADING_TEXT}>
      <div className="SeismicPlayer">
        <div className={`SeismicPlayer--${isPractice ? 'practice' : 'player'}`}>
          <Suspense fallback={<ElementLoading isLoading text={LOADING_TEXT} />}>
            <SeismicPlayer
              config={playerConfiguration}
              lang={languageMapper()}
              mode="read"
              autoplay={autoplay}
              verifySignature={false} // Seismic player complains that the verify signature failed and causes it not render (since we do not have any functionality related to watermarking, we can safely disable this)
            />
          </Suspense>
        </div>
        {universalLink && (
          <a
            href={universalLink}
            className="SeismicPlayer--link"
            target="_blank"
            rel="noreferrer"
          >
            <ExternalLink size={12} />
            <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD_LINK}>
              {t('questions.types.content.view_content')}
            </Text>
          </a>
        )}
      </div>
    </ElementLoading>
  );
};

export default UniversalPlayer;
